"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasChanged = exports.hasChanged = function hasChanged(propName) {
  return function (oldProps, newProps) {
    return oldProps[propName] !== newProps[propName];
  };
};
var hasNotChanged = exports.hasNotChanged = function hasNotChanged(propName) {
  return function (oldProps, newProps) {
    return oldProps[propName] === newProps[propName];
  };
};
var noLonger = exports.noLonger = function noLonger(propName) {
  return function (oldProps, newProps) {
    return oldProps[propName] && !newProps[propName];
  };
};
var now = exports.now = function now(propName) {
  return function (oldProps, newProps) {
    return !oldProps[propName] && newProps[propName];
  };
};
var stayedTrue = exports.stayedTrue = function stayedTrue(propName) {
  return function (oldProps, newProps) {
    return oldProps[propName] && newProps[propName];
  };
};
var stayedFalse = exports.stayedFalse = function stayedFalse(propName) {
  return function (oldProps, newProps) {
    return !oldProps[propName] && !newProps[propName];
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/react/propsComparisons.js
// module id = 147
// module chunks = 0